import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from 'src/_services/translate.service';
import { ApiService } from 'src/_services/api.service';
import { first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
declare var $: any;

@Component({
  selector: 'app-verify-employer',
  templateUrl: './verify-employer.component.html',
  styleUrls: ['./verify-employer.component.scss']
})
export class VerifyEmployerComponent implements OnInit, OnDestroy {
  NIFResponse: any;
  CNSSResponse: any;
  modalHeading: string;
  modalDescription: string;
  isSuccessModal: boolean = false;
  CNAMGSResponse: any;
  ManagerResponse: any;
  modalStatus: string;
  reasonText: string;
  isEmployee: boolean = false;
  deviceToken: string;
  uuid: string;
  deviceDetails: any;
  responseToken: any;
  isSubmittedOTP: boolean;
  NIF_number: any;
  NIF_email: any;
  NIFResponseOtp: any;
  CnssCnamgsResponse: any;
  employerDetailsResponse: any;
  responseupload: any;
  companyFcURL: any;
  companyFc: any;
  managerIdProofURL: any;
  agent_managerIdProofURL: any;
  agent_managerPowerOfattorneyURL: any;
  agent_managerPowerOfattorney: any;
  EmployeeResponse: any;
  nip_number: any;
  email_employee: any;
  isEmployeeConfirm: boolean = false;
  isSubmittedEmployeeDetail: boolean = false;
  EmployeeSubmitResponse: any;
  cnssSectionValue: any;
  cnamgsSectionValue: any;
  companyName: any;
  companyNif: any;
  rejectedBy: any;
  rejectedDate: any;
  reasonText2: any;
  companyId: any;
  CNSSVerifyResponse: any;
  CNSSVerifyStatus: boolean = false;
  cnssValidateAttempted: boolean = false;
  cnssValidatedNumber: string | null = null;
  cnssSubmitAttempted: boolean = false;

  constructor(private formBuilder: FormBuilder, private translate: TranslateService, private api: ApiService, private snackBar: MatSnackBar, private ngxUiLoaderService: NgxUiLoaderService, private router: Router, private route: ActivatedRoute) { }

  public verifyNIFForm: FormGroup;
  public verifyCNSSForm: FormGroup;
  public verifyCnamgsForm: FormGroup;
  public verifyCompanyForm: FormGroup;
  public verifyManagerForm: FormGroup;
  public verifyEmployeeForm: FormGroup;
  public otpFormSignIn: FormGroup;
  isNIFSection: boolean = false;
  isCNSSSection: boolean = false;
  isCNSSSectionValue: boolean = false;
  isCnamgsSection: boolean = false;
  isCnamgsSectionValue: boolean = false;
  isSubmittedCnss: boolean = false;
  isSubmittedCnamgs: boolean = false;
  isSubmittedNIF: boolean = false;
  isSubmittedManager: boolean = false;
  isSubmittedEmployee: boolean = false;
  private subscriptions: Subscription[] = [];
  managerIdProof: any;
  agent_managerIdProof: any;
  isEmployerDetailsSection: boolean = false;
  currentLang: any;
  public languageForm: FormGroup;
  isVerifyAsSection: boolean = true;
  isEmployeeIDSection: boolean = false;
  isEmployeeDetailSection: boolean = false;
  timerSeconds: number = 60;
  isResendEnabled: boolean = false;
  isOTPSection: boolean = true;
  isEmployeeYesVerifySection: boolean = false;
  private timerInterval: any;
  isRejected = false;
  isCnssCnamgs: boolean = false;
  /** When true, API indicates an individual company (DGI name is the owner's name). */
  legalNatureStatus: boolean = false;
  flowType: string;
  managerPowerOfattorney: any

  private t(key: string): string {
    return (this.translate && this.translate.data && this.translate.data[key]) ? this.translate.data[key] : key;
  }

  ngOnInit() {
    this.languageForm = this.formBuilder.group({
      lang: ['', []],
    });

    this.currentLang = localStorage.getItem('language') || "fr";
    this.languageForm.get('lang').setValue(this.currentLang);
    if (this.currentLang == 'fr') {
      $('.checkbox').prop('checked', false);
    } else {
      $('.checkbox').prop('checked', true);
    }
    if (this.currentLang == 'fr') {
      $('.myCheckbox').prop('checked', true);
      $("#lang").text("FR");
    } else {
      $('.myCheckbox').prop('checked', false);
      $("#lang").text("EN");
    }
    console.log(this.languageForm.get('lang').value);
    this.getDeviceDetails();

    this.verifyNIFForm = this.formBuilder.group({
      nif_number: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]]

    });

    this.verifyCNSSForm = this.formBuilder.group({
      is_reg_cnss: [1, [Validators.required]],
      cnss_number: ['', [Validators.required]],
    });

    this.verifyCnamgsForm = this.formBuilder.group({
      is_reg_cnamgs: [1, [Validators.required]],
      cnamgs_number: ['', [Validators.required]],
    });

    this.verifyCompanyForm = this.formBuilder.group({
      company_name_entered: ['', []],
      company_fc: ['', []],
    });

    this.verifyManagerForm = this.formBuilder.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phone_number: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(8), Validators.maxLength(8)]],
      managerIdProof: ['', [Validators.required]],
      // NOTE: UI currently only collects agent power-of-attorney (agent_managerPowerOfattorney),
      // so keep managerPowerOfattorney optional to avoid blocking submit.
      managerPowerOfattorney: ['', []],
      agent_first_name: ['',],
      agent_last_name: ['',],
      agent_email: ['',],
      agent_phone_number: ['', [Validators.pattern("^[0-9]*$"), Validators.minLength(8), Validators.maxLength(8)]],
      agent_managerIdProof: [''],
      agent_managerPowerOfattorney: ['', []]
    });
    this.verifyEmployeeForm = this.formBuilder.group({
      nip_number: ['', [Validators.required]],
      email: ['', [Validators.required]]
    });

    this.otpFormSignIn = this.formBuilder.group({
      otp1: ['', [Validators.required]],
      otp2: ['', [Validators.required]],
      otp3: ['', [Validators.required]],
      otp4: ['', [Validators.required]]
    });

    // Initialize OTP input handling
    setTimeout(() => {
      this.initializeOtpInputs();
    }, 0);

    // Subscribe to changes in is_reg_cnss to update validators
    const isRegCnssControl = this.verifyCNSSForm.get('is_reg_cnss');
    if (isRegCnssControl) {
      const subscription = isRegCnssControl.valueChanges.subscribe(value => {
        const cnssNumberControl = this.verifyCNSSForm.get('cnss_number');

        if (cnssNumberControl) {
          if (value === 1) {
            cnssNumberControl.setValidators([Validators.required]);
          } else {
            cnssNumberControl.clearValidators();
            cnssNumberControl.setValue('');
          }
          cnssNumberControl.updateValueAndValidity();
        }

        this.isCnssCnamgs = this.isCnssCnamgsValue;
        this.updateCompanySupplementValidators();
      });
      this.subscriptions.push(subscription);
    }

    // Reset CNSS validation state when CNSS number changes (forces re-Validate only if edited)
    const cnssNumberControl = this.verifyCNSSForm.get('cnss_number');
    if (cnssNumberControl) {
      const subscription = cnssNumberControl.valueChanges.subscribe((value: any) => {
        const current = ((value !== null && value !== undefined) ? value : '').toString();
        if (this.cnssValidatedNumber !== null && current === this.cnssValidatedNumber) {
          return;
        }

        // If user edits the CNSS number after validation/prefill, require re-validation
        this.CNSSVerifyStatus = false;
        this.cnssValidateAttempted = false;
        this.cnssSubmitAttempted = false;
      });
      this.subscriptions.push(subscription);
    }

    // Subscribe to changes in is_reg_cnamgs to update validators
    const isRegCnamgsControl = this.verifyCnamgsForm.get('is_reg_cnamgs');
    if (isRegCnamgsControl) {
      const subscription = isRegCnamgsControl.valueChanges.subscribe(value => {
        const cnamgsNumberControl = this.verifyCnamgsForm.get('cnamgs_number');

        if (cnamgsNumberControl) {
          if (value === 1) {
            cnamgsNumberControl.setValidators([Validators.required]);
          } else {
            cnamgsNumberControl.clearValidators();
            cnamgsNumberControl.setValue('');
          }
          cnamgsNumberControl.updateValueAndValidity();
        }

        this.isCnssCnamgs = this.isCnssCnamgsValue;
        this.updateCompanySupplementValidators();
      });
      this.subscriptions.push(subscription);
    }

    this.updateCompanySupplementValidators();

    // Start the timer when component initializes
    this.startTimer();

    // Read slug from URL and restore section state
    this.route.params.subscribe(params => {
      const slug = params['slug'];
      if (slug) {
        if (slug === 'employer') {
          this.isEmployee = false;
          this.isVerifyAsSection = false;
          this.isNIFSection = true;
        } else if (slug === 'employee') {
          this.isEmployee = true;
          this.isEmployeeIDSection = true;
          this.isVerifyAsSection = false;
        } else if (slug === 'employer-details') {
          // Read NIF_number and NIF_email from sessionStorage
          const storedNif = sessionStorage.getItem('verify_employer_nif');
          const storedEmail = sessionStorage.getItem('verify_employer_email');

          if (storedNif) {
            this.NIF_number = storedNif;
          }
          if (storedEmail) {
            this.NIF_email = storedEmail;
          }

          // If we have NIF_number, fetch the details
          if (this.NIF_number) {
            this.isEmployee = false;
            this.isVerifyAsSection = false;

            this.fetchCnssCnamgsDetails();
          }
        } else if (slug === 'employer-resubmit') {
          // Read NIF_number and NIF_email from sessionStorage
          this.isVerifyAsSection = false;
          const storedNif = sessionStorage.getItem('verify_employer_nif');
          const storedEmail = sessionStorage.getItem('verify_employer_email');

          if (storedNif) {
            this.NIF_number = storedNif;
          }
          if (storedEmail) {
            this.NIF_email = storedEmail;
          }
          if (this.NIF_number && this.NIF_email) {
            const data = {
              nif_number: this.NIF_number,
              email: this.NIF_email
            }
            this.getEmployerDetails(data);
          }
        }
      }
    });
  }


  getUuid() {

    const data = localStorage.getItem('device_id');
    if (data) {
      this.deviceToken = data;
      console.log("deviceToken fcm", this.deviceToken)
    } else {

      const pushtoken = localStorage.getItem('pushtoken');
      if (pushtoken) {
        this.uuid = pushtoken;
        console.log("uuid", this.uuid)
        this.generateDeviceToken();
      } else {
        console.log("297")
        const timestamp = new Date().getTime();
        const array = new Uint32Array(8);
        window.crypto.getRandomValues(array);
        let token = '';
        array.forEach(value => {
          token += value.toString(16);
        });
        this.uuid = `${token}-${timestamp}`;
        console.log("uuid", this.uuid)
        this.generateDeviceToken();
      }


    }

  }
  getDeviceDetails() {
    this.deviceDetails = {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      appName: navigator.appName,
      appVersion: navigator.appVersion,
      vendor: navigator.vendor
    };
    console.log("332", this.deviceDetails)
    this.getUuid();
  }
  generateDeviceToken() {

    if (this.uuid) {
      this.ngxUiLoaderService.start();
      let data = {
        uuid: this.uuid,
        device: this.deviceDetails
      }
      this.api.generateToken(data).pipe(first())
        .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.responseToken = res;
          if (this.responseToken.status == 200) {

            this.deviceToken = this.responseToken.token;
            console.log(this.deviceToken)
            localStorage.setItem('device_id', this.deviceToken);
          } else {

            // this.snackBar.open(this.response.message, "OK", {
            //     duration: 5000,
            // });
          }

        },
          error => {
            this.ngxUiLoaderService.stop();
          });
    }

  }

  private initializeOtpInputs(): void {
    const inputs = document.querySelectorAll(".otpVerifyOtp input");
    const allInputs = Array.from(inputs);

    if (allInputs.length === 0) {
      // Inputs not yet in DOM, try again after a short delay
      setTimeout(() => this.initializeOtpInputs(), 100);
      return;
    }

    allInputs.forEach((input, index) => {
      const inputElement = input as HTMLElement;
      inputElement.dataset.index = index.toString();

      inputElement.addEventListener("keyup", this.handleOtp.bind(this, allInputs));
      inputElement.addEventListener("paste", this.handleOnPasteOtp.bind(this, allInputs));
    });
  }

  private handleOtp(allInputs: Element[], e: KeyboardEvent): void {
    const input = e.target as HTMLInputElement;
    let value = input.value;
    let isValidInput = value.match(/[0-9a-z]/gi);
    input.value = "";
    input.value = isValidInput ? value[0] : "";

    // Trigger input event to ensure Angular form control is updated
    input.dispatchEvent(new Event('input', { bubbles: true }));

    let fieldIndex = parseInt(input.dataset.index || "0");
    let nextElement = input.nextElementSibling as HTMLElement;
    let prevElement = input.previousElementSibling as HTMLElement;

    if (nextElement && fieldIndex < allInputs.length - 1 && isValidInput) {
      nextElement.focus();
    }

    if (e.key === "Backspace" && prevElement && fieldIndex > 0) {
      prevElement.focus();
    }
  }

  private handleOnPasteOtp(allInputs: Element[], e: ClipboardEvent): void {
    e.preventDefault();
    const data = e.clipboardData ? e.clipboardData.getData("text") : null;
    if (!data) return;

    const value = data.split("").filter(char => char.match(/[0-9a-z]/gi));

    // Use allInputs.length to check the length
    if (value.length === allInputs.length) {
      allInputs.forEach((input, index) => {
        const inputElement = input as HTMLInputElement;
        const charValue = value[index] || "";
        inputElement.value = charValue;
        // Trigger input event to ensure Angular form control is updated
        inputElement.dispatchEvent(new Event('input', { bubbles: true }));
      });
      // Focus the last input after pasting
      const lastInput = allInputs[allInputs.length - 1] as HTMLElement;
      lastInput.focus();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
    // Clear timer interval on destroy
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  startTimer() {
    this.timerSeconds = 60;
    this.isResendEnabled = false;

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      if (this.timerSeconds > 0) {
        this.timerSeconds--;
      } else {
        clearInterval(this.timerInterval);
        this.isResendEnabled = true;
      }
    }, 1000);
  }

  onResendOTP() {
    if (this.isResendEnabled) {
      this.ngxUiLoaderService.start();
      // Reset timer and disable resend button

      // Add your resend OTP logic here
      const data = {
        email: this.NIF_email,
        entity_type: this.isEmployee === true ? 2 : 1,
      }

      this.api.VerifyOtpResend(data).pipe(first())
        .subscribe(res => {
          this.ngxUiLoaderService.stop();
          console.log('792', res)
          if (res.status == 200) {
            this.startTimer();
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          } else {

            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }

        },
          error => {
            this.ngxUiLoaderService.stop();
          });

    }
  }

  onValidateCnssNumber(): void {
    // TODO: validation API call logic will be added here
    const cnssNumber = this.verifyCNSSForm.get('cnss_number').value;
    console.log('Validate CNSS:', cnssNumber);



    this.ngxUiLoaderService.start();
    const data = {
      company_id: this.companyId,
      cnss_number: cnssNumber,
      nif_number: this.companyNif
    }


    this.api.ValidateCnssNumber(data).pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        this.CNSSVerifyResponse = res;
        // Mark that user attempted validation for the current value
        this.cnssValidateAttempted = true;
        if (this.CNSSVerifyResponse.status == 200) {

          this.CNSSVerifyStatus = true;
          this.cnssValidatedNumber = cnssNumber;
          // Switch UI to the "value display" section using the validated CNSS number
          this.cnssSectionValue = cnssNumber;
          this.isCNSSSectionValue = true;
          this.isCNSSSection = false;

          this.snackBar.open(this.CNSSVerifyResponse.message, "OK", {
            duration: 5000,
          });
        } else {
          this.CNSSVerifyStatus = false;
          this.cnssValidatedNumber = null;
          // Keep manual section visible on failed validation
          this.isCNSSSectionValue = false;
          this.isCNSSSection = true;
          this.snackBar.open(this.CNSSVerifyResponse.message, "OK", {
            duration: 5000,
          });
        }

      },
        error => {
          this.ngxUiLoaderService.stop();
        });

  }

  get g() { return this.verifyNIFForm.controls; };
  get gCNSS() { return this.verifyCNSSForm.controls; };
  get gCnamgs() { return this.verifyCnamgsForm.controls; };
  get gCompany() { return this.verifyCompanyForm.controls; };
  get gManager() { return this.verifyManagerForm.controls; };
  get gEmployee() { return this.verifyEmployeeForm.controls; };
  get i() { return this.otpFormSignIn.controls; }

  get isRegCnssValue(): number {
    const control = this.verifyCNSSForm.get('is_reg_cnss');
    return control ? control.value : 0;
  }

  get isRegCnamgsValue(): number {
    const control = this.verifyCnamgsForm.get('is_reg_cnamgs');
    return control ? control.value : 0;
  }

  get isCnssCnamgsValue(): boolean {
    // Returns true if either CNSS or CNAMGS is set to "No" (value 0)
    return this.isRegCnssValue === 0 || this.isRegCnamgsValue === 0;
  }

  get shouldShowManagerForm(): boolean {
    // Always show manager/agent form when in employer details so companies
    // without CNSS or CNAMGS can still submit manager and agent details.
    return this.isEmployerDetailsSection;
  }

  /** Single FC block: manual CNSS, manual CNAMGS, or individual company (legal nature). */
  get showCommonFc(): boolean {
    return (this.isCNSSSection && this.isRegCnssValue === 1) ||
      (this.isCnamgsSection && this.isRegCnamgsValue === 1) ||
      this.legalNatureStatus;
  }

  private normalizeLegalNatureStatus(value: any): boolean {
    if (value === true || value === 1 || value === '1') {
      return true;
    }
    if (typeof value === 'string' && value.toLowerCase() === 'true') {
      return true;
    }
    return false;
  }

  updateCompanySupplementValidators(): void {
    const nameCtrl = this.verifyCompanyForm.get('company_name_entered');
    const fcCtrl = this.verifyCompanyForm.get('company_fc');
    if (!nameCtrl || !fcCtrl) {
      return;
    }

    if (this.legalNatureStatus) {
      nameCtrl.setValidators([Validators.required]);
    } else {
      nameCtrl.clearValidators();
      nameCtrl.setValue('');
    }
    nameCtrl.updateValueAndValidity({ emitEvent: false });

    if (this.showCommonFc) {
      if (this.companyFc || this.companyFcURL) {
        fcCtrl.clearValidators();
      } else {
        fcCtrl.setValidators([Validators.required]);
      }
    } else {
      fcCtrl.clearValidators();
      fcCtrl.setValue('');
      this.companyFc = null;
      this.companyFcURL = null;
    }
    fcCtrl.updateValueAndValidity({ emitEvent: false });
  }


  openNav() {
    document.getElementById("mySidenav").style.width = "305px";
    document.getElementById("main").style.marginRight = "0px";
    document.getElementById("menuOverlay").style.display = "block";

  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("main").style.marginRight = "0";
    document.getElementById("menuOverlay").style.display = "none";
  }
  getChangelang(e) {
    if (e.target.checked == true) {
      var lang = 'en';
    } else {
      lang = 'fr';
    }
    this.setLang(lang)
  }

  setLang(lang) {
    console.log('aaa')
    // console.log(lang.target.value)
    // console.log(lang.detail.value)
    // console.log(lang)
    this.currentLang = lang;
    var useLang = { language: this.currentLang };
    this.translate.setCurrentLangage(useLang);
    localStorage.setItem('language', lang);

    this.changeLang();
  }

  changeLang() {
    this.translate.use(this.currentLang);
  }


  onVerifyAs(type: any) {
    // Navigate with slug parameter - stay in verify-employer route
    this.router.navigate([type], { relativeTo: this.route });

    if (type == 'employee') {
      this.isEmployee = true;
      this.isEmployeeIDSection = true;
      this.isVerifyAsSection = false;
    } else if (type == 'employer') {
      this.isEmployee = false;
      this.isVerifyAsSection = false;
      this.isNIFSection = true;
    }
  }


  onSubmitVerifyNIF(type?: any) {
    this.flowType = type;

    this.isSubmittedNIF = true;
    if (this.verifyNIFForm.invalid) {
      return;
    }

    const data = {
      ...this.verifyNIFForm.value,
      entity_type: 1,
      device_token: this.deviceToken

    }
    console.log(data);
    // $('#verifyNIFModal').modal('show');
    // $('#otpVerifyModal').modal('show');
    // $('#companyNotFoundModal').modal('show');



    this.ngxUiLoaderService.start();
    this.api.verifyNIF(data).pipe(first()).subscribe(res => {
      this.ngxUiLoaderService.stop();
      this.NIFResponse = res.result;
      if (res.status == 200) {
        console.log(res, 'res');
        this.isSubmittedNIF = false;
        this.verifyNIFForm.reset();
        this.isEmployeeYesVerifySection = false;
        this.isOTPSection = true;
        this.startTimer();
        $('#otpVerifyModal').modal('show');
        this.NIF_number = this.NIFResponse.nif_number;
        this.NIF_email = this.NIFResponse.email;

        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });


      } else {

        this.isSuccessModal = false;
        this.modalHeading = '';
        this.modalDescription = res.message;
        this.modalStatus = 'close';
        $('#companyNotFoundModal').modal('show');


        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });

      }
    },
      error => {
        this.ngxUiLoaderService.stop();
        this.snackBar.open(error.message, "OK", {
          duration: 5000,
        });
      });

  }

  /**
   * Fetch CNSS/CNAMGS details from API
   */
  private fetchCnssCnamgsDetails(): void {
    if (!this.NIF_number) {
      return;
    }

    var data = {
      nif_number: this.NIF_number
    };

    this.ngxUiLoaderService.start();
    this.api.getCnssCnamgsDetails(data).pipe(first()).subscribe(res => {
      this.ngxUiLoaderService.stop();
      this.CnssCnamgsResponse = res.result;
      $('#otpVerifyModal').modal('hide');
      if (res.status == 200) {
        this.isNIFSection = false;
        this.isEmployerDetailsSection = true;
        this.companyName = this.CnssCnamgsResponse.company_name;
        this.companyId = this.CnssCnamgsResponse.company_id;
        this.companyNif = this.CnssCnamgsResponse.nif_number;
        if (this.CnssCnamgsResponse.cnss.status) {
          this.isCNSSSectionValue = true;
          this.cnssSectionValue = this.CnssCnamgsResponse.cnss.number;
        } else {
          this.isCNSSSection = true;
        }

        if (this.CnssCnamgsResponse.cnamgs.status) {
          this.isCnamgsSectionValue = true;
          this.cnamgsSectionValue = this.CnssCnamgsResponse.cnamgs.number;
        } else {
          this.isCnamgsSection = true;
        }
        this.legalNatureStatus = this.normalizeLegalNatureStatus(this.CnssCnamgsResponse.legal_nature_status);
        this.updateCompanySupplementValidators();
        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });
      } else {
        this.isNIFSection = true;
        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });
      }
    },
      error => {
        this.isNIFSection = true;
        this.ngxUiLoaderService.stop();
        this.snackBar.open(error.message, "OK", {
          duration: 5000,
        });
      });
  }

  onYesVerifyNIF(yes: boolean, type?: any) {
    console.log(this.flowType, 'this.flowType');
    console.log(this.isEmployee, 'this.isEmployee');



    if (!this.isEmployee) {
      if (yes) {
        // Store NIF_number and NIF_email in sessionStorage for persistence across refresh
        sessionStorage.setItem('verify_employer_nif', this.NIF_number);
        sessionStorage.setItem('verify_employer_email', this.NIF_email);

        // Navigate to "employer-details" without query parameters
        this.router.navigate(['/verify-employer/employer-details']);

        // Call the API function
        // this.fetchCnssCnamgsDetails();

      } else {
        $('#otpVerifyModal').modal('hide');
        this.isNIFSection = true;


      }

    } else {
      if (yes) {
        this.isEmployeeDetailSection = true;
        this.isEmployeeIDSection = false;
        $('#otpVerifyModal').modal('hide');

      } else {
        $('#otpVerifyModal').modal('hide');
        this.isEmployeeIDSection = true;
        this.isEmployeeDetailSection = false;
      }
    }


    return;

    if (this.flowType == 'with-value') {
      if (type) {
        this.isNIFSection = false;
        this.isCNSSSectionValue = true;
        this.isCnamgsSectionValue = true;
        this.isEmployerDetailsSection = true;

        $('#otpVerifyModal').modal('hide');

        this.snackBar.open('NIF details submitted successfully', "OK", {
          duration: 5000,
        });
      } else {
        this.isNIFSection = true;
        this.isCNSSSectionValue = false;
        this.isCnamgsSectionValue = false;
        this.isEmployerDetailsSection = false;

        $('#otpVerifyModal').modal('hide');

        // this.snackBar.open('NIF details submitted successfully', "OK", {
        //   duration: 5000,
        // });
      }

    } else if (this.flowType == 'without-cnns&cnamgs-value') {
      this.isNIFSection = false;
      this.isCNSSSection = true;
      this.isCnamgsSection = true;
      this.isEmployerDetailsSection = true;

      $('#otpVerifyModal').modal('hide');

      this.snackBar.open('NIF details submitted successfully', "OK", {
        duration: 5000,
      });
    } else if (this.flowType == 'Resubmit') {

    }




  }


  closeVerifyNIFModal() {
    this.verifyNIFForm.reset();
    $('#verifyNIFModal').modal('hide');

  }









  onBack(type: any) {

    if (type === 'resubmit') {

      // turn off all resubmit related sections
      this.isCNSSSection = false;
      this.isCNSSSectionValue = false;
      this.isCnamgsSection = false;
      this.isCnamgsSectionValue = false;
      this.isEmployerDetailsSection = false;
      this.isNIFSection = false;
      this.isEmployeeDetailSection = false;
      this.isEmployeeIDSection = false;

      // go back to Verify As
      this.isVerifyAsSection = true;
      // Clear sessionStorage when going back
      sessionStorage.removeItem('verify_employer_nif');
      sessionStorage.removeItem('verify_employer_email');
      this.router.navigate(['/verify-employer']);

    } else if (type == 'nif') {
      this.isNIFSection = false;
      this.isEmployerDetailsSection = false;
      this.isEmployeeDetailSection = false;
      this.isEmployeeIDSection = false;
      this.isVerifyAsSection = true;
      this.router.navigate(
        ['/verify-employer'],
        { replaceUrl: true }
      );
    }
    else if (type === 'employee') {

      this.isEmployeeIDSection = false;

      this.isEmployerDetailsSection = false;
      this.isEmployeeDetailSection = false;

      this.isVerifyAsSection = true;

      this.router.navigate(
        ['/verify-employer'],
        { replaceUrl: true }
      );
    } else if (type == 'employee-detail') {

      this.isEmployeeDetailSection = false;

      this.isEmployerDetailsSection = false;

      this.isEmployeeIDSection = true;

      this.router.navigate(
        ['/verify-employer/employee'],
        { replaceUrl: true }
      );
    }

    else {
      window.location.reload();
    }

  }

  onYesVerifyEmployee() {
    $('#otpVerifyModalEmployee').modal('hide');
    this.isEmployeeDetailSection = true;
    this.isEmployeeIDSection = false;
  }


  onSubmitVerifyEmployee() {
    this.isSubmittedEmployee = true;
    if (this.verifyEmployeeForm.invalid) {
      return;
    }

    const data = {
      ...this.verifyEmployeeForm.value,
      entity_type: 2,
      device_token: this.deviceToken

    }

    console.log(data, 'employee valuess');


    this.ngxUiLoaderService.start();
    this.api.verifyNIF(data).pipe(first()).subscribe(res => {
      this.ngxUiLoaderService.stop();
      this.EmployeeResponse = res.result;
      if (res.status == 200) {
        console.log(res, 'res');
        this.isSubmittedEmployee = false;
        this.verifyEmployeeForm.reset();
        $('#otpVerifyModal').modal('show');
        this.startTimer();
        this.nip_number = this.EmployeeResponse.nip_number;
        this.email_employee = this.EmployeeResponse.email;

        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });


      } else {

        this.isSuccessModal = false;
        this.modalHeading = '';
        this.modalDescription = res.message;
        this.modalStatus = 'close';
        $('#companyNotFoundModal').modal('show');


        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });

      }
    },
      error => {
        this.isSubmittedEmployee = false;
        this.verifyEmployeeForm.reset();
        this.ngxUiLoaderService.stop();
        this.snackBar.open(error.message, "OK", {
          duration: 5000,
        });
      });



  }


  closeOTPVerifyModal() {
    this.isOTPSection = true;
    this.isEmployeeYesVerifySection = false;
    this.otpFormSignIn.reset();
    this.isSubmittedOTP = false;
    $('#otpVerifyModal').modal('hide');
  }

  onOTPVerify() {
    this.isSubmittedOTP = true;
    if (this.otpFormSignIn.invalid) {
      return;
    }

    var data = {};

    if (this.isEmployee) {
      data = {
        otp: this.i.otp1.value + this.i.otp2.value + this.i.otp3.value + this.i.otp4.value,
        entity_type: 2,
        nip_number: this.nip_number,
        email: this.email_employee
      }
    } else {
      data = {
        otp: this.i.otp1.value + this.i.otp2.value + this.i.otp3.value + this.i.otp4.value,
        entity_type: 1,
        nif_number: this.NIF_number,
        email: this.NIF_email
      }
    }



    console.log(data, 'data');

    this.ngxUiLoaderService.start();
    this.api.verifyNIFOtp(data).pipe(first()).subscribe(res => {
      this.ngxUiLoaderService.stop();
      this.NIFResponseOtp = res.result;
      if (res.status == 200) {
        console.log(res, 'res');
        this.isSubmittedOTP = false;
        this.otpFormSignIn.reset();

        if (this.NIFResponseOtp.company_status == 4) {

          // Store NIF_number and NIF_email in sessionStorage (already stored, but ensure it's there)
          sessionStorage.setItem('verify_employer_nif', this.NIF_number);
          sessionStorage.setItem('verify_employer_email', this.NIF_email);

          this.router.navigate(['/verify-employer/employer-resubmit']);

          const data = {
            nif_number: this.NIF_number,
            email: this.NIF_email
          }
          this.getEmployerDetails(data);

          $('#otpVerifyModal').modal('hide');
        } else if (this.NIFResponseOtp.company_status == 1) {
          $('#otpVerifyModal').modal('hide')
          $('#companyNotFoundModal').modal('hide')
          // this.modalHeading = 'Approved'
          this.isSuccessModal = true;
          this.modalDescription = res.message
          this.modalStatus = 'close';
          $('#companyNotFoundModal').modal('show');

        }
        else {
          this.isOTPSection = false;
          this.isEmployeeYesVerifySection = true;
          this.legalNatureStatus = this.NIFResponseOtp.legal_nature_status;
        }




        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });
      } else {
        this.isSubmittedOTP = false;
        this.otpFormSignIn.reset();
        this.isOTPSection = true;
        this.isEmployeeYesVerifySection = false;
        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });
      }
    },
      error => {

        this.isOTPSection = true;
        this.isEmployeeYesVerifySection = false;

        this.ngxUiLoaderService.stop();
        this.snackBar.open(error.message, "OK", {
          duration: 5000,
        });
      });




  }

  getEmployerDetails(data: any) {
    this.ngxUiLoaderService.start();
    this.api.getEmployerDetails(data).pipe(first()).subscribe(res => {
      this.ngxUiLoaderService.stop();

      if (res.status == 200) {
        // Store the response for later use in payload

        if (res.result.rejected_by) {
          this.isRejected = true;
          this.reasonText = res.result.reason;
          this.reasonText2 = res.result.reason_2;
          this.rejectedBy = res.result.rejected_by;
          this.rejectedDate = res.result.process_date;
        }
        this.employerDetailsResponse = res;
        this.isNIFSection = false;
        this.isEmployerDetailsSection = true;
        this.companyName = res.result.company_name;
        this.companyNif = res.result.nif;
        this.companyId = res.result.company_id;
        this.legalNatureStatus = this.normalizeLegalNatureStatus(res.result.legal_nature_status);
        if (res.result.is_cnss_dgi) {
          this.isCNSSSectionValue = true;
          this.cnssSectionValue = res.result.cnss_number;
        } else {
          this.isCNSSSection = true;

          if (this.verifyCNSSForm) {
            this.verifyCNSSForm.patchValue({
              is_reg_cnss: res.result.is_cnss ? 1 : 0,
              cnss_number: res.result.cnss_number
            });
          }


        }
        if (res.result.is_cnamgs_dgi) {
          this.isCnamgsSectionValue = true;
          this.cnamgsSectionValue = res.result.cnamgs_number;
        } else {
          this.isCnamgsSection = true;
          if (this.verifyCnamgsForm) {
            this.verifyCnamgsForm.patchValue({
              is_reg_cnamgs: res.result.is_cnamgs ? 1 : 0,
              cnamgs_number: res.result.cnamgs_number
            });
          }
        }
        const fcUrl = res.result.company_fc_url || res.result.support_doc_cnss_url || res.result.support_doc_cnamgs_url;
        const fcFile = res.result.company_fc || res.result.support_doc_cnss || res.result.support_doc_cnamgs;
        if (fcUrl || fcFile) {
          this.companyFcURL = fcUrl;
          this.companyFc = fcFile;
        }
        if (this.legalNatureStatus && this.verifyCompanyForm) {
          const entered =
            res.result.company_name_entered;
         
            
          if (entered != null && entered !== '') {
            this.verifyCompanyForm.patchValue({ company_name_entered: entered }, { emitEvent: false });
          }
        }
        if (this.verifyManagerForm) {
          this.verifyManagerForm.patchValue({
            first_name: res.result.manager_agent.first_name,
            last_name: res.result.manager_agent.last_name,
            email: res.result.manager_agent.email,
            phone_number: res.result.manager_agent.phone_number,
            agent_first_name: res.result.manager_agent.agent_first_name,
            agent_last_name: res.result.manager_agent.agent_last_name,
            agent_email: res.result.manager_agent.agent_email,
            agent_phone_number: res.result.manager_agent.agent_phone_number
          });

          this.managerIdProofURL = res.result.manager_agent.managerIdProof_url;
          this.managerIdProof = res.result.manager_agent.managerIdProof;
          this.verifyManagerForm.get('managerIdProof').setValidators([]);
          this.verifyManagerForm.get('managerIdProof').updateValueAndValidity();

          this.agent_managerIdProofURL = res.result.manager_agent.agent_managerIdProof_url;
          this.agent_managerIdProof = res.result.manager_agent.agent_managerIdProof;
          this.verifyManagerForm.get('agent_managerIdProof').setValidators([]);
          this.verifyManagerForm.get('agent_managerIdProof').updateValueAndValidity();

          this.agent_managerPowerOfattorneyURL = res.result.manager_agent.agent_managerPowerOfattorney_url;
          this.agent_managerPowerOfattorney = res.result.manager_agent.agent_managerPowerOfattorney;
          this.verifyManagerForm.get('agent_managerPowerOfattorney').setValidators([]);
          this.verifyManagerForm.get('agent_managerPowerOfattorney').updateValueAndValidity();
        }
        this.updateCompanySupplementValidators();
        $('#otpVerifyModal').modal('hide');

        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });
      } else {
        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });
      }
    },
      error => {
        this.ngxUiLoaderService.stop();
        this.snackBar.open(error.message, "OK", {
          duration: 5000,
        });
      });
  }

  /** Returns the form control for the given upload field id (for setting fileType error). */
  private getUploadFormControl(id: string): any {
    switch (id) {
      case 'company_fc': return this.verifyCompanyForm ? this.verifyCompanyForm.get('company_fc') : null;
      case 'managerIdProof':
      case 'agent_managerIdProof':
      case 'agent_managerPowerOfattorney': return this.verifyManagerForm ? this.verifyManagerForm.get(id) : null;
      default: return null;
    }
  }

  upload(event: any, id): void {
    console.log("2250", event)
    console.log("597 id :", id)
    console.log("2251", event.target.files[0])

    if (event.target.files.length > 0) {

      const file = event.target.files[0];
      console.log('uploaded image: ', file)
      const filename = file.name;
      var ext = filename.split('.').pop();
      if (file.size > 5242880) {

        if (this.currentLang == 'fr') {
          alert('La taille du fichier doit être inférieure à 5MB')
        } else {
          alert('File Size should be less than 5MB')
        }
        return;
      }
      if (id == 'employeePhoto') {
        console.log("541  Employee Photo")
        if (ext != 'jpg' && ext != 'JPG' && ext != 'png' && ext != 'PNG' && ext != 'JPEG' && ext != 'jpeg' && ext != 'bmp' && ext != 'BMP' && ext != 'webp' && ext != 'heic' && ext != 'HEIC' && ext != 'heif' && ext != 'HEIF' && ext != 'tiff' && ext != 'TIFF' && ext != 'tif' && ext != 'TIF') {
          if (this.currentLang == 'fr') {
            alert('Type de fichier non autorisé. Les types de fichier autorisés sont  .jpg .png .jpeg .bmp .webp .heic .heif .tiff')
          } else {
            alert('File type not allowed. Allowed file types are .jpg .png .jpeg .bmp .webp .heic .heif .tiff')
          }
          return;
        }
      } else {
        // Verify employer uploads: only .jpg .png .jpeg .pdf .heic .heif
        const allowedExts = ['jpg', 'jpeg', 'png', 'pdf', 'heic', 'heif'];
        const extLower = (ext || '').toLowerCase();
        if (!allowedExts.includes(extLower)) {
          const control = this.getUploadFormControl(id);
          if (control) {
            control.setErrors({ ...(control.errors || {}), fileType: true });
            control.updateValueAndValidity();
          }
          event.target.value = '';
          if (this.currentLang == 'fr') {
            alert('Type de fichier non autorisé. Types autorisés : .jpg .png .jpeg .pdf .heic .heif')
          } else {
            alert('File type not allowed. Allowed file types are .jpg .png .jpeg .pdf .heic .heif')
          }
          return;
        }
        // Clear fileType error if re-uploading with valid type
        const control = this.getUploadFormControl(id);
        if (control && control.errors && control.errors.fileType) {
          const errs = control.errors;
          const rest: any = {};
          for (const k in errs) {
            if (k !== 'fileType') { rest[k] = errs[k]; }
          }
          control.setErrors(Object.keys(rest).length ? rest : null);
          control.updateValueAndValidity();
        }
      }
      this.ngxUiLoaderService.start();
      const target = event.target.dataset.target;
      console.log(target)
      const formData = new FormData();
      formData.append('image', file);
      formData.append('target', target);
      console.log("file is :", file)
      console.log("target is :", target)
      console.log("607", formData)
      formData['encrypt_mode'] = false;
      // formData.append('uuid', this.businessData.business_code);
      this.api.uploadVerifyDocument(formData).pipe(first())
        .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.responseupload = data;
          if (this.responseupload.status == 200) {

            if (id == 'company_fc') {
              this.companyFcURL = this.responseupload.results.imageUrl;
              this.companyFc = this.responseupload.results.file;
              const fcCtrl = this.verifyCompanyForm.get('company_fc');
              if (fcCtrl) {
                fcCtrl.clearValidators();
                fcCtrl.updateValueAndValidity();
              }
            } else if (id == 'managerIdProof') {
              this.managerIdProofURL = this.responseupload.results.imageUrl;
              this.managerIdProof = this.responseupload.results.file;
              this.verifyManagerForm.get('managerIdProof').setValidators([]);
              this.verifyManagerForm.get('managerIdProof').updateValueAndValidity();
            } else if (id == 'agent_managerIdProof') {
              this.agent_managerIdProofURL = this.responseupload.results.imageUrl;
              this.agent_managerIdProof = this.responseupload.results.file;
              this.verifyManagerForm.get('agent_managerIdProof').setValidators([]);
              this.verifyManagerForm.get('agent_managerIdProof').updateValueAndValidity();
            } else if (id == 'agent_managerPowerOfattorney') {
              this.agent_managerPowerOfattorneyURL = this.responseupload.results.imageUrl;
              this.agent_managerPowerOfattorney = this.responseupload.results.file;
              this.verifyManagerForm.get('agent_managerPowerOfattorney').setValidators([]);
              this.verifyManagerForm.get('agent_managerPowerOfattorney').updateValueAndValidity();
            }

            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });



          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
          error => {
            this.ngxUiLoaderService.stop();
            this.snackBar.open(error.message, "OK", {
              duration: 5000,
            });
          });



    }
  }


  onSubmitVerifyManager() {
    // Set all submitted flags to show validation errors
    this.isSubmittedCnss = true;
    this.isSubmittedCnamgs = true;
    this.isSubmittedManager = true;
    this.cnssSubmitAttempted = true;

    this.updateCompanySupplementValidators();
    if (this.showCommonFc) {
      const fcCtrl = this.verifyCompanyForm.get('company_fc');
      if (fcCtrl) {
        if (this.companyFc || this.companyFcURL) {
          fcCtrl.clearValidators();
        } else {
          fcCtrl.setValidators([Validators.required]);
        }
        fcCtrl.updateValueAndValidity();
      }
      if (this.verifyCompanyForm.invalid) {
        return;
      }
    }

    // Validate CNSS form if section is shown and user selected "Yes"
    if (this.isCNSSSection && this.isRegCnssValue === 1) {
      if (this.verifyCNSSForm.invalid) {
        return;
      }

      // Extra rule: Require CNSS "Validate" click before submit (after field validations show)
      if (!this.cnssValidateAttempted) {
        this.snackBar.open(this.t('Please validate CNSS number to proceed.'), "OK", {
          duration: 5000,
        });
        return;
      }
    }

    // Validate CNAMGS form if section is shown and user selected "Yes"
    if (this.isCnamgsSection && this.isRegCnamgsValue === 1) {
      if (this.verifyCnamgsForm.invalid) {
        return;
      }
    }

    // Validate Manager form only if it should be shown
    if (this.shouldShowManagerForm) {
      if (this.verifyManagerForm.invalid) {
        return;
      }
    }

    // Build payload in the exact API format (flat object)

    // Check if this is a resubmit flow
    const isResubmitFlow = this.route.snapshot.params['slug'] === 'employer-resubmit';

    // Determine nif_number based on flow type
    let nifNumber: string;
    if (isResubmitFlow && this.employerDetailsResponse && this.employerDetailsResponse.result) {
      // For resubmit flow, get nif_number from employerDetailsResponse
      nifNumber = this.employerDetailsResponse.result.nif_number || this.employerDetailsResponse.result.nif;
    } else {
      // For normal flow, use existing logic
      nifNumber = (this.CnssCnamgsResponse && this.CnssCnamgsResponse.nif_number) ? this.CnssCnamgsResponse.nif_number : this.NIF_number;
    }

    const payload: any = {
      entity_type: 1,
      nif_number: nifNumber
    };

    // Add manager_id, agent_id, and company_id if available from employerDetailsResponse
    if (this.employerDetailsResponse && this.employerDetailsResponse.result) {
      if (this.employerDetailsResponse.result.manager_agent) {
        payload.manager_id = this.employerDetailsResponse.result.manager_agent.manager_id || this.employerDetailsResponse.result.manager_agent.id;
        payload.agent_id = this.employerDetailsResponse.result.manager_agent.agent_id;
      }
      payload.company_id = this.employerDetailsResponse.result.company_id;
    }

    // Manager fields
    if (this.shouldShowManagerForm) {
      payload.first_name = this.verifyManagerForm.value.first_name;
      payload.last_name = this.verifyManagerForm.value.last_name;
      payload.email = this.verifyManagerForm.value.email;
      payload.phone_number = this.verifyManagerForm.value.phone_number;
      payload.managerIdProof = this.managerIdProof || this.verifyManagerForm.value.managerIdProof;

      payload.agent_first_name = this.verifyManagerForm.value.agent_first_name;
      payload.agent_last_name = this.verifyManagerForm.value.agent_last_name;
      payload.agent_email = this.verifyManagerForm.value.agent_email;
      payload.agent_phone_number = this.verifyManagerForm.value.agent_phone_number;
      payload.agent_managerIdProof = this.agent_managerIdProof || this.verifyManagerForm.value.agent_managerIdProof;
      payload.agent_managerPowerOfattorney = this.agent_managerPowerOfattorney || this.verifyManagerForm.value.agent_managerPowerOfattorney;
    }

    if (this.legalNatureStatus) {
      payload.company_name_entered = this.verifyCompanyForm.value.company_name_entered;
    }

    const fc = this.companyFc;
    const needCnssFc = this.isCNSSSection && this.isRegCnssValue === 1;
    const needCnamgsFc = this.isCnamgsSection && this.isRegCnamgsValue === 1;
    const needIndividualFc = this.legalNatureStatus && !needCnssFc && !needCnamgsFc;

    let support_doc_cnss: any = null;
    if (this.isCNSSSectionValue) {
      support_doc_cnss = needIndividualFc ? fc : null;
    } else if (this.isCNSSSection) {
      support_doc_cnss = this.isRegCnssValue === 1 ? fc : null;
    } else if (needIndividualFc) {
      support_doc_cnss = fc;
    }

    let support_doc_cnamgs: any = null;
    if (this.isCnamgsSectionValue) {
      support_doc_cnamgs = needIndividualFc ? fc : null;
    } else if (this.isCnamgsSection) {
      support_doc_cnamgs = this.isRegCnamgsValue === 1 ? fc : null;
    } else if (needIndividualFc) {
      support_doc_cnamgs = fc;
    }

    // CNSS number + doc + boolean flag
    if (this.isCNSSSectionValue) {
      payload.cnss_number = (this.CnssCnamgsResponse && this.CnssCnamgsResponse.cnss) ? this.CnssCnamgsResponse.cnss.number : null;
      payload.support_doc_cnss = support_doc_cnss;
      payload.is_cnss = true;
    } else if (this.isCNSSSection) {
      payload.cnss_number = this.isRegCnssValue === 1 ? this.verifyCNSSForm.value.cnss_number : null;
      payload.support_doc_cnss = support_doc_cnss;
      payload.is_cnss = this.isRegCnssValue === 1;
    }

    // CNAMGS number + doc + boolean flag
    if (this.isCnamgsSectionValue) {
      payload.cnamgs_number = (this.CnssCnamgsResponse && this.CnssCnamgsResponse.cnamgs) ? this.CnssCnamgsResponse.cnamgs.number : null;
      payload.support_doc_cnamgs = support_doc_cnamgs;
      payload.is_cnamgs = true;
    } else if (this.isCnamgsSection) {
      payload.cnamgs_number = this.isRegCnamgsValue === 1 ? this.verifyCnamgsForm.value.cnamgs_number : null;
      payload.support_doc_cnamgs = support_doc_cnamgs;
      payload.is_cnamgs = this.isRegCnamgsValue === 1;
    }

    // Common FC field expected by API (from get api keys: company_fc, company_fc_url)
    if (this.showCommonFc) {
      payload.company_fc = fc;
    }

    console.log(payload, 'submit payload');

    this.ngxUiLoaderService.start();
    this.api.verifyManager(payload).pipe(first()).subscribe(res => {
      this.ngxUiLoaderService.stop();
      this.ManagerResponse = res.results;
      if (res.status == 200) {
        this.isSubmittedManager = false;
        this.isSubmittedCnss = false;
        this.isSubmittedCnamgs = false;

        // Reset forms on success
        if (this.shouldShowManagerForm) {
          this.verifyManagerForm.reset();
        }
        if (this.isCNSSSection && this.isRegCnssValue === 1) {
          this.verifyCNSSForm.reset();
        }
        if (this.isCnamgsSection && this.isRegCnamgsValue === 1) {
          this.verifyCnamgsForm.reset();
        }
        this.verifyCompanyForm.reset();
        this.companyFc = null;
        this.companyFcURL = null;
        this.updateCompanySupplementValidators();

        $('#companyNotFoundModal').modal('show');
        this.isSuccessModal = true;
        this.modalHeading = res.message;
        // this.modalDescription = 'We will verify the company details within 7 working days and update you through email.';
        this.modalDescription = '' ;
        this.modalStatus = 'close-home';

        // this.snackBar.open(res.message, "OK", {
        //   duration: 5000,
        // });
      } else {
        $('#companyNotFoundModal').modal('show');
        this.isSuccessModal = false;
        this.modalHeading = '';
        this.modalDescription = res.message;
        this.modalStatus = 'close';

        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });
      }
    },
      error => {
        this.ngxUiLoaderService.stop();
        this.snackBar.open(error.message, "OK", {
          duration: 5000,
        });
      });





  }


  statusModal(status: any) {
    console.log(status, 'status');

    if (status == 'close-home') {
      $('#companyNotFoundModal').modal('hide');
      this.router.navigate(['/']);
    } else if (status == 'close') {
      $('#companyNotFoundModal').modal('hide');

    }
  }




  onSubmitVerifyEmployeeDetail() {
    this.isSubmittedEmployeeDetail = true;
    if (!this.isEmployeeConfirm) {
      return;
    }

    var data = {
      entity_type: 2,
      nif_number: this.NIFResponseOtp.nif,
      employee_id: this.NIFResponseOtp.employee_id,
      employee_nip_number: this.NIFResponseOtp.nip_number,
    }

    this.ngxUiLoaderService.start();
    this.api.verifyManager(data).pipe(first()).subscribe(res => {
      this.ngxUiLoaderService.stop();
      this.EmployeeSubmitResponse = res.result;
      if (res.status == 200) {

        this.isSubmittedEmployeeDetail = false;
        this.isEmployeeConfirm = false;

        $('#companyNotFoundModal').modal('show');
        this.isSuccessModal = true;
        this.modalHeading = 'Employee details added successfully';
        this.modalDescription = 'We will verify the employee details and update you through email.';
        this.modalStatus = 'close-home';

        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });
      } else {
        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });
      }
    },
      error => {
        this.ngxUiLoaderService.stop();
        this.snackBar.open(error.message, "OK", {
          duration: 5000,
        });
      });



  }


}
